const usProduct = {
  product: {
    accordion: {
      'returns-and-exchanges': 'Returns'
    },
    personalisation: {
      cost: '$10.00'
    },
    'returns-and-exchanges-instructions': {
      lines:
        'Delivery in 4-6 working days | Free US 200-day returns - no questions, no catches | Human customer care - no chatbots'
    }
  }
}

module.exports = usProduct
